<script setup lang="ts">
    // Dark plan-name pill (lightning + uppercase plan name) shared across the upsell
    // surfaces so the style stays aligned with the subscription page. `size` switches
    // between the compact (sidebar / desktop modal) and larger (mobile modal) variants.
    withDefaults(
        defineProps<{
            name: string;
            size?: 'sm' | 'md';
        }>(),
        {
            size: 'sm',
        }
    );
</script>

<template>
    <div
        class="bg-action-darkBlue inline-flex items-center rounded-full"
        :class="size === 'md' ? 'gap-1.5 px-3.5 py-3' : 'gap-1.5 px-3 py-2'"
    >
        <i
            class="fa-sharp fa-solid fa-bolt text-action-cyan"
            :class="size === 'md' ? 'text-pill-icon-md' : 'text-pill-icon-sm'"
        />
        <span
            class="font-medium text-white uppercase font-inter"
            :class="size === 'md' ? 'text-pill-md leading-pill-md' : 'text-pill-sm leading-pill-sm'"
        >
            {{ name }}
        </span>
    </div>
</template>
